module.exports = __webpack_public_path__ + "img/ic_airmoney_micro.42b7a28.svg";